document.addEventListener('DOMContentLoaded', function() {
  console.log('Custom Subscription Script Loaded');

  const variantMap = window.customSubscriptionData;
  const currencySymbol = window.shopCurrency || '$';
  
  // Element References
  const rightTotalDisplay = document.querySelector('#right-column-total');
  const mainProductForm = document.querySelector('form[action*="/cart/add"]');
  const masterIdInput = document.querySelector('input[name="id"]');
  const sizeCards = document.querySelectorAll('.size-card');
  const cadenceBtns = document.querySelectorAll('.cadence-btn');
  const allSteps = document.querySelectorAll('.sub-step');

  // Pill References
  const pillSize = document.querySelector('.pill-size');
  const pillCadence = document.querySelector('.pill-cadence');
  const pillDate = document.querySelector('.pill-date');
  const pillNote = document.querySelector('.pill-note');

  if (!variantMap) {
    console.error("Error: Variant Data not found in window.customSubscriptionData.");
    return;
  }

  // --- Accordion Logic with Mobile Scroll ---
  allSteps.forEach(step => {
    const header = step.querySelector('.step-header');
    if(header) {
      header.addEventListener('click', () => {
        // 1. Store the current state of the clicked step
        const isActive = step.classList.contains('is-active');
        
        // 2. Close all steps (keeps the accordion exclusive)
        allSteps.forEach(s => s.classList.remove('is-active'));
        
        // 3. If it wasn't active before the click, open it and scroll
        if (!isActive) {
            step.classList.add('is-active');
            
            if (window.innerWidth < 990) {
                setTimeout(() => {
                    const headerOffset = 80; 
                    const elementPosition = step.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  
                    window.scrollTo({
                         top: offsetPosition,
                         behavior: 'smooth'
                    });
                }, 150); 
            }
        }
      });
    }
  });

  // --- Smart "Note" Pill Visibility Checker ---
  const updateNotePillVisibility = () => {
    if (!pillNote) return;
    
    const noteInput = document.querySelector('#easify-note-container textarea, #easify-note-container input');
    const hasText = noteInput && noteInput.value && noteInput.value.trim().length > 0;

    // Check if ALL other fields have been selected
    const hasSize = pillSize && pillSize.style.display !== 'none';
    const hasCadence = pillCadence && pillCadence.style.display !== 'none';
    const hasDate = pillDate && pillDate.style.display !== 'none';
    const allOthersSelected = hasSize && hasCadence && hasDate;

    if (hasText) {
        // If they typed something, show it immediately
        pillNote.textContent = 'Note Added';
        pillNote.style.display = 'inline-block';
    } else if (allOthersSelected) {
        // Only show "No Note" if everything else is filled out
        pillNote.textContent = 'No Note';
        pillNote.style.display = 'inline-block';
    } else {
        // Hide if neither condition is met
        pillNote.style.display = 'none';
    }
  };

  // --- Update Total & Pills ---
  const updateSubscriptionTotal = () => {
    const selectedSizeCard = document.querySelector('.size-card.selected');
    if (!selectedSizeCard) return;

    const sizeName = selectedSizeCard.dataset.value.trim();
    const variantData = variantMap[sizeName];
    if (!variantData || !variantData.price) return;

    const selectedFreqBtn = document.querySelector('.cadence-btn.selected');
    let discountPercent = selectedFreqBtn ? parseFloat(selectedFreqBtn.dataset.discount) : 30;

    let finalPrice = variantData.price;
    if (discountPercent > 0) {
        finalPrice = finalPrice * (1 - (discountPercent / 100));
    }

    const priceFormatted = (finalPrice / 100).toFixed(2); 
    if (rightTotalDisplay) {
        rightTotalDisplay.innerHTML = `${currencySymbol}${priceFormatted}`;
    }
  };

  const selectSize = (card) => {
      sizeCards.forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');

      const nameToSelect = card.dataset.value.trim();
      
      if(pillSize) {
        const titleEl = card.querySelector('h3');
        if(titleEl) {
            pillSize.textContent = titleEl.textContent.trim();
            pillSize.style.display = 'inline-block';
        }
      }

      updateNotePillVisibility();

      const variantData = variantMap[nameToSelect]; 
      if (variantData && variantData.id) {
        if (masterIdInput) masterIdInput.value = variantData.id;

        const optionName = window.subscriptionConfig?.variantOptionName || 'Plan';
        const planSelect = document.querySelector(`select[name="options[${optionName}]"]`);
        if (planSelect) {
           const options = Array.from(planSelect.options);
           const targetOption = options.find(opt => opt.value.trim() === nameToSelect);
           if (targetOption) planSelect.value = targetOption.value;
        }
        
        updateSubscriptionTotal();
      }
  };

  sizeCards.forEach(card => {
    card.addEventListener('click', function(e) {
      e.preventDefault();
      selectSize(this);
    });
  });

  cadenceBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      cadenceBtns.forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      
      if(pillCadence) {
         const titleSpan = this.querySelector('.btn-title');
         if(titleSpan) {
             pillCadence.textContent = titleSpan.textContent.trim();
             pillCadence.style.display = 'inline-block';
         }
      }

      updateNotePillVisibility();
      updateSubscriptionTotal();
      
      const zapierInput = document.getElementById('zapier-frequency');
      if (zapierInput) zapierInput.value = this.dataset.searchTerm; 
    });
  });

  // --- Dynamic Date formatting for Pill ---
  const updateDatePill = (val) => {
    if(val.trim().length > 0) {
        let dStr = val.replace(/-/g, '/');
        let d = new Date(dStr);
        
        if (!isNaN(d)) {
            const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
            if(pillDate) {
                pillDate.textContent = `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
                pillDate.style.display = 'inline-block';
            }
        } else {
            if(pillDate) {
                pillDate.textContent = `(${val})`; 
                pillDate.style.display = 'inline-block';
            }
        }
    } else {
        if(pillDate) pillDate.style.display = 'none';
    }
    updateNotePillVisibility();
  };

  const handleDateChange = function(e) {
    if(e.target.tagName === 'INPUT') updateDatePill(e.target.value);
  };
  
  document.getElementById('easify-date-container').addEventListener('change', handleDateChange);
  document.getElementById('easify-date-container').addEventListener('input', handleDateChange);

  // Monitor Note Field
  document.getElementById('easify-note-container').addEventListener('input', function(e) {
    if(e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT') {
        updateNotePillVisibility();
    }
  });

  // --- Easify Field Teleport Logic ---
  const moveEasifyField = (labelText, targetContainerId, displayLabel = null) => {
    const targetContainer = document.getElementById(targetContainerId);
    if (!targetContainer) return false;

    const allLabels = document.querySelectorAll('.tpo_option-label span.form__label');
    const matchingLabel = Array.from(allLabels).find(el => {
        return el && el.textContent && el.textContent.trim().includes(labelText);
    });

    if (matchingLabel) {
      if (displayLabel) matchingLabel.textContent = displayLabel;
      
      const optionWrapper = matchingLabel.closest('.tpo_option-container');
      if (optionWrapper) {
        targetContainer.appendChild(optionWrapper);
        optionWrapper.style.display = 'block'; 
        return true;
      }
    }
    return false;
  };

  let attempts = 0;
  const teleportInterval = setInterval(() => {
    attempts++;

    const labels = window.easifyLabels || { 
        dateMatch: "Receive By", 
        dateDisplay: "First Delivery Date", 
        location: "Send to", 
        message: "Message" 
    };

    const dateMoved = moveEasifyField(labels.dateMatch, "easify-date-container", labels.dateDisplay);
    const addressMoved = moveEasifyField(labels.location, "easify-location-container");
    const messageMoved = moveEasifyField(labels.message, "easify-note-container");

    if (dateMoved && addressMoved && messageMoved) {
       const formId = mainProductForm ? mainProductForm.getAttribute('id') : null;
       if(formId) {
         document.querySelectorAll('#easify-date-container input, #easify-location-container input, #easify-note-container textarea').forEach(input => {
            input.setAttribute('form', formId);
         });
       }

       const dateInput = document.querySelector('#easify-date-container input');
       if(dateInput && dateInput.value) updateDatePill(dateInput.value);
       updateNotePillVisibility();

       clearInterval(teleportInterval);
    }
    
    if (attempts >= 40) clearInterval(teleportInterval);
  }, 500);

  // --- Mobile Sticky Footer Scroll Animation ---
  const stickySummary = document.querySelector('.flex-stretch-block');
  const firstStep = document.querySelector('.step-1');

  const handleMobileScroll = () => {
    if (window.innerWidth < 990 && stickySummary && firstStep) {
        const step1Rect = firstStep.getBoundingClientRect();
        if (step1Rect.bottom < (window.innerHeight / 2)) {
            stickySummary.classList.add('is-visible-mobile');
        } else {
            stickySummary.classList.remove('is-visible-mobile');
        }
    } else if (stickySummary) {
        stickySummary.classList.remove('is-visible-mobile');
    }
  };

  window.addEventListener('scroll', handleMobileScroll, { passive: true });
  window.addEventListener('resize', handleMobileScroll, { passive: true });
  handleMobileScroll();

  // --- Unified Add To Cart Logic ---
  const handleAddToCart = function(e) {
    e.preventDefault();

    let isValid = true;
    
    // Validate Size Selection
    const selectedSize = document.querySelector('.size-card.selected');
    if (!selectedSize) {
        isValid = false;
        const step1 = document.querySelector('.step-1');
        allSteps.forEach(s => s.classList.remove('is-active'));
        if(step1) {
            step1.classList.add('is-active');
            step1.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
        return; 
    }

    // Validate Cadence Selection
    const selectedBtn = document.querySelector('.cadence-btn.selected');
    if (!selectedBtn) {
        isValid = false;
        const step2 = document.querySelector('.step-2');
        allSteps.forEach(s => s.classList.remove('is-active'));
        if(step2) {
            step2.classList.add('is-active');
            step2.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
        return; 
    }

    // Validate Easify Inputs
    const easifyInputs = document.querySelectorAll('.custom-sub-flow .tpo_option-input, .custom-sub-flow .tpo_text-box, .custom-sub-flow textarea');
    easifyInputs.forEach(input => {
      const isRequired = input.getAttribute('data-required') === '1' || input.hasAttribute('required');
      const container = input.closest('.tpo_option-container');
      const errorDiv = container ? container.querySelector('.tpo_error-message') : null;

      if(errorDiv) {
           errorDiv.style.display = 'none';
           errorDiv.innerText = '';
      }
      if(input.style.border) input.style.border = ''; 

      if (isRequired && !input.value.trim()) {
          isValid = false;
          if (errorDiv) {
              errorDiv.style.display = 'block';
              errorDiv.innerText = "This field is required"; 
              errorDiv.style.color = '#d04343';
              errorDiv.style.marginTop = '5px';
          }
          input.style.border = '1px solid #d04343';
      }
    });

    if (!isValid) {
       const firstError = document.querySelector('.tpo_option-container .tpo_error-message[style*="block"]');
       if(firstError) {
           const stepParent = firstError.closest('.sub-step') || firstError.closest('.step-content');
           if(stepParent && stepParent.classList.contains('sub-step')) {
               allSteps.forEach(s => s.classList.remove('is-active'));
               stepParent.classList.add('is-active');
           }
           if(stepParent) stepParent.scrollIntoView({behavior: 'smooth', block: 'center'});
       }
       return; 
    }

    // Form Submission Compilation
    let targetForm = document.querySelector('form[action*="/cart/add"][id^="product-form-template--"]');
    if (targetForm && targetForm.offsetParent === null) {
        const visibleForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(f => f.offsetParent !== null);
        if (visibleForm) targetForm = visibleForm;
    }

    if (targetForm) {
      const customInputs = document.querySelectorAll('.custom-sub-flow input, .custom-sub-flow textarea, .custom-sub-flow select');
      customInputs.forEach(input => {
          if(input.value && input.name && !input.name.includes('search_term')) {
              let hiddenInput = targetForm.querySelector(`input[type="hidden"][name="${input.name}"]`);
              if (!hiddenInput) {
                  hiddenInput = document.createElement('input');
                  hiddenInput.type = 'hidden';
                  hiddenInput.name = input.name;
                  targetForm.appendChild(hiddenInput);
              }
              hiddenInput.value = input.value;
          }
      });

      if (selectedSize) {
          const sizeName = selectedSize.dataset.value.trim();
          const variantData = variantMap[sizeName];
          
          if (variantData && variantData.id) {
              let hiddenIdInput = targetForm.querySelector('input[name="id"]');
              if (!hiddenIdInput) {
                   hiddenIdInput = document.createElement('input');
                   hiddenIdInput.type = 'hidden';
                   hiddenIdInput.name = 'id';
                   targetForm.appendChild(hiddenIdInput);
              }
              hiddenIdInput.value = variantData.id;
          }
      }

      const sellingPlanSelect = document.querySelector('select[name="selling_plan"]');
      let correctPlanId = null;

      if (selectedBtn && sellingPlanSelect) {
          const searchTerm = selectedBtn.dataset.searchTerm.toLowerCase();
          const options = Array.from(sellingPlanSelect.options);
          const correctOption = options.find(opt => {
              const text = (opt.innerText || "").toLowerCase();
              const label = (opt.getAttribute('data-plan-option') || "").toLowerCase();
              return text.includes(searchTerm) || label.includes(searchTerm);
          });
          if (correctOption) correctPlanId = correctOption.value;
      }

      if (correctPlanId) {
          let hiddenPlanInput = targetForm.querySelector('input[type="hidden"][name="selling_plan"]');
          if (!hiddenPlanInput) {
              hiddenPlanInput = document.createElement('input');
              hiddenPlanInput.type = 'hidden';
              hiddenPlanInput.name = 'selling_plan';
              targetForm.appendChild(hiddenPlanInput);
          }
          hiddenPlanInput.value = correctPlanId;
      }

      if (targetForm.requestSubmit) {
          targetForm.requestSubmit();
      } else {
          targetForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
  };

  // Attach the Add to Cart logic to both the Desktop and Mobile buttons
  const customAddBtn = document.getElementById('CustomAddToCart');
  const customAddBtnMobile = document.getElementById('CustomAddToCartMobile');

  if(customAddBtn) customAddBtn.addEventListener('click', handleAddToCart);
  if(customAddBtnMobile) customAddBtnMobile.addEventListener('click', handleAddToCart);

});